import PrimaryButton from "../../elements/primary-button";
import BodyText from "../../elements/body-text";
import React from "react";
import PropTypes from "prop-types";
import "./style.scss";

const BecomeAMember = ({ isMember, user, queryInStore, heading, perksHTML, button, linksTitle, linksHTML }) => {
  return (
    <div className="membership-cta">
      {!queryInStore && <h4 className="type-h4">{heading}</h4>}
      {!queryInStore && <BodyText html={perksHTML} />}
      {!isMember && !user && !queryInStore && <PrimaryButton {...button} />}
      <h4 className="type-h4">{linksTitle}</h4>
      <BodyText tagName={"p"} html={linksHTML} />
    </div>
  );
};

BecomeAMember.propTypes = {
  heading: PropTypes.string,
  perksHTML: PropTypes.string,
  button: PropTypes.shape(PrimaryButton.propTypes),
  linksTitle: PropTypes.string,
  linksHTML: PropTypes.string
};

export default BecomeAMember;
